import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1ccd25ba"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head clearfix"
};
const _hoisted_2 = {
  class: "header-top"
};
const _hoisted_3 = {
  class: "head-top"
};
const _hoisted_4 = {
  class: "head-logo"
};
const _hoisted_5 = {
  href: "/index.html"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "head-infor"
};
const _hoisted_8 = ["href", "target"];
const _hoisted_9 = ["href"];
const _hoisted_10 = ["href"];
const _hoisted_11 = {
  key: 0,
  class: "head-login"
};
const _hoisted_12 = ["href"];
const _hoisted_13 = {
  key: 1,
  class: "head-user"
};
const _hoisted_14 = {
  class: "avatar-box"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "user-name"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("账号设置");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("退出");

const _hoisted_19 = {
  ref: "pride_tab_fixed",
  style: {
    "margin-top": "30px"
  }
};
const _hoisted_20 = {
  class: "head-nav"
};
const _hoisted_21 = ["href", "target"];
const _hoisted_22 = {
  class: "fixPostion"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_ArrowUp = _resolveComponent("ArrowUp");

  const _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", $props.page == '设置' ? 'header-set' : ''])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("a", _hoisted_5, [$data.logoUrl ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.logoUrl,
    alt: ""
  }, null, 8, _hoisted_6)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_7, [$data.headList.length && ($data.zhsRole == 1 || $data.userRole == 1) ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.headList, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      class: "guard-center",
      key: index,
      href: item.target_url ? item.target_url : '',
      target: item.target_type ? '_blank' : '_self'
    }, _toDisplayString(item.name), 9, _hoisted_8);
  }), 128)) : _createCommentVNode("", true), $data.onlineTeache && ($data.zhsRole || $data.userRole) ? (_openBlock(), _createElementBlock("a", {
    key: 1,
    class: "online",
    href: $data.onlineTeache ? $data.onlineTeache.target_url : '',
    target: "_blank"
  }, _toDisplayString($data.onlineTeache.name), 9, _hoisted_9)) : _createCommentVNode("", true), $data.userInfo && $data.userInfo.roleList && $data.userInfo.roleList.length ? (_openBlock(), _createElementBlock("a", {
    key: 2,
    class: "online",
    href: $data.backUrl,
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.goBackPlat && _ctx.goBackPlat(...args)),
    target: "_blank"
  }, " 管理后台 ", 8, _hoisted_10)) : _createCommentVNode("", true), $data.showLogin ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [!$data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("a", {
    href: _ctx.$zhsLoginUrl,
    target: "_self"
  }, "登录", 8, _hoisted_12)])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    class: "avatar",
    src: $data.userInfo.avatar ? $data.userInfo.avatar : require('../../assets/images/user_icon.png')
  }, null, 8, _hoisted_15)]), _createVNode(_component_el_dropdown, {
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        onClick: $options.goAccountSet
      }, {
        default: _withCtx(() => [_hoisted_17]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
        onClick: $options.logout
      }, {
        default: _withCtx(() => [_hoisted_18]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_16, _toDisplayString($data.userInfo.realname), 1)]),
    _: 1
  })]))], 64)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    class: _normalizeClass(["head-btn", {
      'btn-none': $props.page == '设置',
      isFixed: $data.titleFixed == true
    }])
  }, [_createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.navList.slice(0, 10), ({
    menu_name,
    target_url,
    target_type
  }, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["nav-btn", $data.currentPage === menu_name ? 'nav-active' : ''])
    }, [_createElementVNode("a", {
      href: target_url,
      style: _normalizeStyle({
        'width': menu_name.length * 18 + 84 + 'px'
      }),
      class: "noticenav",
      target: target_type ? '_blank' : '_self'
    }, _toDisplayString(menu_name), 13, _hoisted_21)], 2);
  }), 128))])], 2)], 512), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
    class: "back-top",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.backTop && $options.backTop(...args))
  }, [_createVNode(_component_el_icon, {
    size: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowUp)]),
    _: 1
  })])])])], 2);
}